import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://api.sm-media.id';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal mengirim email');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'linear-gradient(135deg, #0a0e1a 0%, #111827 100%)' }}>
      <div style={{ width: '100%', maxWidth: 400, background: '#111827', border: '1px solid #1e2d45', borderRadius: 16, padding: 32 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 24 }}>
          <span style={{ fontSize: 32, fontWeight: 700, background: 'linear-gradient(135deg, #f59e0b, #fbbf24)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>SM</span>
          <span style={{ fontSize: 14, fontWeight: 600, color: '#94a3b8', letterSpacing: 3 }}>MEDIA</span>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
            <h2 style={{ color: '#f1f5f9', marginBottom: 8 }}>Email Terkirim!</h2>
            <p style={{ color: '#94a3b8', fontSize: 14, marginBottom: 24 }}>Cek inbox kamu untuk link reset password. Link valid selama 1 jam.</p>
            <Link to="/login" style={{ color: '#f59e0b', fontSize: 14 }}>← Kembali ke Login</Link>
          </div>
        ) : (
          <>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 }}>Lupa Password</h1>
            <p style={{ fontSize: 14, color: '#94a3b8', marginBottom: 28 }}>Masukkan email akun kamu</p>
            {error && <div style={{ background: '#450a0a', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 13, color: '#94a3b8', marginBottom: 6 }}>Email</label>
                <input type="email" placeholder="email@kamu.com" value={email} onChange={e => setEmail(e.target.value)} required style={{ fontSize: 16 }} />
              </div>
              <button type="submit" className="btn btn-gold" style={{ width: '100%', padding: 14, fontSize: 16 }} disabled={loading}>
                {loading ? 'Mengirim...' : 'Kirim Link Reset'}
              </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14 }}>
              <Link to="/login" style={{ color: '#94a3b8', textDecoration: 'none' }}>← Kembali ke Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
